import React from "react";
import { times } from "ramda";
import moment from "moment";
import Select from "../Select";
import "react-times/css/material/default.css";

export default props => (
  <Select {...props}>
    <option key="" value="" />
    {getTimes(15).map((time, i) => (
      <option key={i} value={time.format("HH:mm")}>
        {time.format("hh:mm A")}
      </option>
    ))}
  </Select>
);

const getTimes = offset =>
  times(
    i =>
      moment()
        .set({
          hour: 6,
          minute: 0
        })
        .add(i * offset, "minutes"),
    18.25 * 60 / offset
  );



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/CustomTimePicker/index.js